import { ChevronLeft } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { useSidebarCollapse } from '@/hooks/useSidebar';
import { cn } from '@/lib/cn';
import { env } from '@/lib/env';
import { SidebarNav } from './SidebarNav';

export function Sidebar() {
  const { collapsed, toggle } = useSidebarCollapse();

  return (
    <aside
      className={cn(
        'hidden shrink-0 flex-col border-r bg-background transition-[width] duration-base ease-out md:flex',
        collapsed ? 'w-16' : 'w-64',
      )}
    >
      <div className={cn('flex items-center border-b px-3 py-4', collapsed ? 'justify-center' : 'justify-between')}>
        {!collapsed && <h1 className="truncate text-lg font-semibold">{env.VITE_APP_NAME}</h1>}
        <Button
          variant="ghost"
          size="sm"
          onClick={toggle}
          aria-label={collapsed ? 'Expandir sidebar' : 'Colapsar sidebar'}
          className={cn('h-8 w-8 p-0', collapsed && 'mx-auto')}
        >
          <ChevronLeft className={cn('h-4 w-4 transition-transform', collapsed && 'rotate-180')} />
        </Button>
      </div>
      <SidebarNav collapsed={collapsed} />
    </aside>
  );
}
